import { Action } from 'redux';
import { DisplayableFile } from './interfaces/displayable-file.interface';

export interface MedigapRequiredDocumentUpload {
  displayableFileObj: DisplayableFile;
  doctype?: string;
}

export interface MedigapRequiredDocumentUploadStateStructure {
  documents: MedigapRequiredDocumentUpload[];
}

/** INITIAL STATE */
const INITIAL_STATE: MedigapRequiredDocumentUploadStateStructure = {
  documents: []
};

/** ACTION TYPES */
const SET_MEDIGAP_FORM_DOCUMENT = 'SET_MEDIGAP_FORM_DOCUMENT';
const REMOVE_MEDIGAP_FORM_DOCUMENT = 'REMOVE_MEDIGAP_FORM_DOCUMENT';
const RESET_MEDIGAP_FORM_DOCUMENTS = 'RESET_MEDIGAP_FORM_DOCUMENTS';

/** ACTION INTERFACE */
export class MedigapFormDocUploadAction implements Action {
  type: string;
  displayableFileObj?: DisplayableFile;
  documentRecord?: string;
  doctype?: string; // this comes from uploading SEP documentation and selecting a document from a customDropdownSelection 
}

export function saveDocUploadId(displayableFileObj: DisplayableFile): MedigapFormDocUploadAction {
  return { type: SET_MEDIGAP_FORM_DOCUMENT, displayableFileObj };
}
export function removeDocUploadId(documentRecord: string): MedigapFormDocUploadAction {
  return { type: REMOVE_MEDIGAP_FORM_DOCUMENT, documentRecord: documentRecord };
}
export function resetDocUpload(): MedigapFormDocUploadAction {
  return { type: RESET_MEDIGAP_FORM_DOCUMENTS };
}

/** REDUCER */
export const MEDIGAP_FORM_DOCUMENT_UPLOAD_REDUCER_NAME = 'MedigapFormDocumentUpload';
export function MedigapFormDocumentUpload(state: MedigapRequiredDocumentUploadStateStructure = INITIAL_STATE, action: MedigapFormDocUploadAction) {
  const copiedState: MedigapRequiredDocumentUploadStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case SET_MEDIGAP_FORM_DOCUMENT:
      
      const item: MedigapRequiredDocumentUpload = {
        displayableFileObj: action.displayableFileObj
      };

      if (action.doctype) {
        item.doctype = action.doctype;
      }

      copiedState.documents.push(item);
      return Object.assign({}, state, copiedState);
    case REMOVE_MEDIGAP_FORM_DOCUMENT:
      copiedState.documents = copiedState.documents.filter(document => document.displayableFileObj.documentRecord !== action.documentRecord);
      return Object.assign({}, state, copiedState);
    case RESET_MEDIGAP_FORM_DOCUMENTS:
      copiedState.documents = INITIAL_STATE.documents;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}
